import React from "react"

const Header = () => (
  <header>
    <div className="container">
      <div className="innerHeader">
        <div className="navigation">
          <nav>
            <a href="https://www.linkedin.com/in/brian-francis-de-guzman/">LinkedIn</a>
            <a href="https://github.com/BrianFrancisDG">GitHub</a>
          </nav>
        </div>
      </div>
    </div>
  </header>
)

export default Header
